import { render } from "./TailorHomeView.vue?vue&type=template&id=d0bb5cb8"
import script from "./TailorHomeView.vue?vue&type=script&lang=js"
export * from "./TailorHomeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__